import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.scss";
import "../public/iconfont/iconfont.css";
import "../public/themes.css";

import Router from "./routers/index.tsx";
import "./global.ts";
import { getAuthorization, getToken, logOut } from "./api/config.ts";
import { RecoilRoot } from "recoil";
// import VConsole from "vconsole";

// const vConsole = new VConsole();
import "./i18n/config";
import * as Sentry from "@sentry/react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import { getUserBrowserType } from "./utils/tool.ts";
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";

axios.defaults.headers.common["Authorization"] = getAuthorization();

// 监听 body 下是否出现 .im-client-handle.default 元素
// function watchImClientHandle(onFound?: (el: Element) => void) {
//   const selector = ".im-client-handle.default";
//   const find = () => document.body?.querySelector(selector);

//   const existing = find();
//   if (existing) {
//     onFound?.(existing);
//     return;
//   }

//   const observer = new MutationObserver(() => {
//     const el = find();
//     if (el) {
//       onFound?.(el);
//       observer.disconnect();
//     }
//   });

//   const startObserve = () => {
//     if (!document.body) return;
//     observer.observe(document.body, { childList: true, subtree: true });
//   };

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startObserve, { once: true });
//   } else {
//     startObserve();
//   }
// }

// if (typeof window !== "undefined") {
//   watchImClientHandle((el) => {
//     console.debug("Detected .im-client-handle.default element under body", el);
//   });
// }

// 设置 auth值
axios.interceptors.response.use(
  function (response) {
    const { data } = response;
    switch (data.code) {
      case 100003:
        localStorage.removeItem("user");
        logOut();
        return response;
        // location.reload();
        break;
      default:
        return response;
    }
    // 返回http响应数据
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.resolve({ data: { msg: error.message } });
    // return Promise.reject(error);
  }
);

// 存储sentry日志记录
async function setupSentry() {
  Sentry.init({
    dsn: "https://b97a1e9071661e94a33b7995bbf5e097@sentry.kxsz.net/3",
    initialScope: (scope) => {
      scope.setTags({
        userBrowser: getUserBrowserType(),
      });
      return scope;
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        tracePropagationTargets: ["localhost", new RegExp(location.origin)],
      }),
    ],
    replaysSessionSampleRate: 0.5,
    replaysOnErrorSampleRate: 1.0,
    release: "publink-web@" + import.meta.env.VITE_RELEASE,
    environment: import.meta.env.MODE,
    tracesSampleRate: 1.0, // 采样率
    beforeSend(event) {
      return event;
    },
  });
  Sentry.setUser({ uid: localStorage.getItem("uid") });
}

if (import.meta.env.MODE !== "development") setupSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<p>请刷新页面</p>}>
    <React.StrictMode>
      <StyleProvider
        hashPriority="high"
        transformers={[legacyLogicalPropertiesTransformer]}
      >
        <RecoilRoot>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#0271E3",
              },
            }}
          >
            <Router />
          </ConfigProvider>
        </RecoilRoot>
      </StyleProvider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);
